import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { GlobalService } from 'app/services/global.service';
import { LocalService } from 'app/services/local.service';
import { PageService } from 'app/services/page-service';

@Component({
  selector: 'app-subscription-expire',
  templateUrl: './subscription-expire.component.html',
  // styleUrls: ['./subscription-expire.component.css']
})
export class SubscriptionExpireComponent implements OnInit {
  @Input() content: any;
  planRecord = {};
  planType = 'monthly';
  activePlan = {};
  planDetails = {};
  loader = false;

  constructor(
    public service: PageService,
    public authService: AuthService,
    public router: Router,
    public localService: LocalService,
    public dialogRef: NgbActiveModal,
    public global: GlobalService
  ) { }

  ngOnInit() {
    // this.loader = true;
    // this.getPlans();
  }
  getPlans() {
    const search = {
      itemPerPage: 1,
      page: 1,
      status: true
    }
    this.service.listPlans(search).then(plans => {
      this.loader = false;
      this.planRecord = plans['data'] ? plans['data'][0] : {};
      for (let plan in this.planRecord['planDetails']) {
        const singlePlan = this.planRecord['planDetails'][plan];
        this.planDetails[singlePlan['type']] = singlePlan;
        if (singlePlan['type'] === this.planType) {
          this.activePlan = singlePlan;
        }
      }
      console.log(this.activePlan);
    })
      .catch(err => {
        this.global.failureErrorModal(err);
      })
  }
  switchPlan(event) {
    if (event.target.checked) {
      this.planType = 'annually';
    } else {
      this.planType = 'monthly';
    }
    this.activePlan = this.planDetails[this.planType];
  }
  viewPlans() {
    this.dialogRef.close({ success: false })
    this.router.navigate(['/plans']);
  }
  close() {
    this.dialogRef.close({ success: false })
  }
  onSubmit() {
    this.dialogRef.close({ success: true })
    this.router.navigate(['/plans'])
  }
}
